module.exports = __webpack_public_path__ + "img/sit.643e9357.png";